var _defs, _path, _rect, _circle, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon2, _polygon3, _polygon4, _polygon5, _a, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriscBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #fbb034;\n      }\n\n      .cls-5 {\n        fill: #1d2d5c;\n      }\n\n      .cls-3 {\n        stroke: #1d2d5c;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m192.79,9.31v-.06H12.41v173.53c-.01.82-.03,1.64-.03,2.47s.02,1.65.03,2.47v1.91h.02c2.33,95.18,80.21,171.62,175.94,171.62s176-78.8,176-176S287.96,11.65,192.79,9.31Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.24,
    y: 27.99,
    width: 37.07,
    height: 37.07
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 188.38,
    cy: 185.26,
    r: 152.7
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "60.75 56.11 58.29 53.11 55.82 56.11 55.82 37.5 60.75 37.5 60.75 56.11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m134.53,162.2c6.42,0,11.16,1.99,15.53,5.97.58.51.58,1.28.06,1.8l-5,5.2c-.45.45-1.15.45-1.6,0-2.37-2.12-5.52-3.27-8.66-3.27-7.25,0-12.57,6.03-12.57,13.22s5.39,13.02,12.64,13.02c3.02,0,6.29-1.09,8.6-3.08.45-.39,1.28-.39,1.67.06l5,5.33c.45.45.39,1.28-.06,1.73-4.36,4.23-9.88,6.22-15.59,6.22-12.83,0-23.16-10.2-23.16-23.03s10.33-23.16,23.16-23.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-2",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m155.84,164.06c0-.64.51-1.22,1.22-1.22h19.18c7.7,0,13.99,6.22,13.99,13.86,0,5.9-3.91,10.65-9.49,12.9l8.79,16.3c.45.83,0,1.86-1.09,1.86h-8.53c-.51,0-.9-.32-1.03-.58l-8.53-17h-4.43v16.36c0,.64-.58,1.22-1.22,1.22h-7.63c-.71,0-1.22-.58-1.22-1.22v-42.47Zm19.57,17.96c2.63,0,4.88-2.44,4.88-5.13s-2.25-4.88-4.88-4.88h-9.49v10.01h9.49Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-3",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m197.54,164.06c0-.64.58-1.22,1.22-1.22h7.7c.64,0,1.22.58,1.22,1.22v42.47c0,.64-.58,1.22-1.22,1.22h-7.7c-.64,0-1.22-.58-1.22-1.22v-42.47Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-4",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m214.86,201.65l3.02-5.33c.51-.83,1.73-.71,2.18-.38.26.13,4.88,3.53,9.11,3.53,2.57,0,4.43-1.6,4.43-3.85,0-2.69-2.25-4.75-6.61-6.48-5.52-2.18-12.45-6.48-12.45-14.18,0-6.35,4.94-12.77,14.82-12.77,6.67,0,11.8,3.4,13.73,4.81.77.45.64,1.6.38,2.05l-3.27,4.94c-.45.71-1.6,1.28-2.18.83-.58-.32-5.26-3.85-9.17-3.85-2.31,0-4.04,1.54-4.04,3.27,0,2.37,1.92,4.17,6.99,6.22,5,1.99,12.96,5.9,12.96,14.63,0,6.61-5.71,13.28-15.14,13.28-8.34,0-12.96-3.46-14.44-4.94-.64-.64-.83-.9-.32-1.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-5",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m271.19,162.2c6.41,0,11.16,1.99,15.53,5.97.58.51.58,1.28.06,1.8l-5,5.2c-.45.45-1.15.45-1.6,0-2.37-2.12-5.52-3.27-8.66-3.27-7.25,0-12.57,6.03-12.57,13.22s5.39,13.02,12.64,13.02c3.02,0,6.29-1.09,8.6-3.08.45-.39,1.28-.39,1.67.06l5,5.33c.45.45.38,1.28-.06,1.73-4.36,4.23-9.88,6.22-15.59,6.22-12.83,0-23.16-10.2-23.16-23.03s10.33-23.16,23.16-23.16Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_-6",
    "data-name": "logoMark &lt;CompoundPathItem&gt;",
    className: "cls-5",
    d: "m292.47,200.85c2.1,0,3.82,1.72,3.82,3.82s-1.72,3.81-3.82,3.81-3.81-1.71-3.81-3.81,1.71-3.82,3.81-3.82Zm0,7c1.76,0,3.17-1.42,3.17-3.17s-1.41-3.17-3.17-3.17-3.17,1.41-3.17,3.17,1.42,3.17,3.17,3.17Zm-1.33-4.93c0-.11.08-.2.2-.2h1.51c.66,0,1.31.39,1.31,1.19s-.56,1.08-.86,1.16c.21.41.42.84.64,1.25.07.13-.03.29-.18.29h-.36c-.08,0-.16-.08-.19-.15l-.59-1.33h-.79v1.27c0,.11-.08.2-.2.2h-.28c-.12,0-.2-.1-.2-.2v-3.48Zm1.71,1.59c.39,0,.64-.28.64-.61,0-.36-.24-.6-.64-.6h-1.04v1.21h1.04Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m62.75,34.56v23.94h-23.94v-23.94h23.94m2-2h-27.94v27.94h27.94v-27.94h0Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.84 37.5 42.05 37.5 42.05 39.54 48.84 39.54 48.84 37.5 48.84 37.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "49.96 44.49 42.05 44.49 42.05 46.53 49.96 46.53 49.96 44.49 49.96 44.49"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "52.38 49.51 42.05 49.51 42.05 51.56 52.38 51.56 52.38 49.51 52.38 49.51"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "50.8 54.07 42.05 54.07 42.05 56.11 50.8 56.11 50.8 54.07 50.8 54.07"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    xlinkHref: 27.7298039215686
  }, /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_",
    "data-name": "logoMark &lt;PathItem&gt;",
    className: "cls-4",
    d: "m188.27,271.09c-49.38,0-89.15-41.91-85.61-92.02,3.01-42.6,37.75-76.94,80.38-79.48,36.67-2.19,68.79,18.81,83.11,49.68.35.74,1.08,1.23,1.9,1.23h19.24c1.46,0,2.51-1.46,2-2.83-15.46-41.52-55.75-70.95-102.84-70.18-56.81.93-103.74,46.8-105.91,103.57-2.34,61.46,46.78,112.02,107.72,112.02,46.27,0,85.7-29.16,100.99-70.09.51-1.37-.53-2.84-2-2.84h-19.25c-.82,0-1.55.48-1.9,1.22-13.66,29.34-43.4,49.74-77.84,49.74Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 375,
    height: 375
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriscBadge);
export default __webpack_public_path__ + "static/media/crisc-badge.5c08193d908306c2c221b17cdbd5c3a1.svg";
export { ForwardRef as ReactComponent };